import { CSVLink } from "react-csv";
import { Download } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import {
  useGetPdfExportsFullQuery,
  useGetUserRegistrationsFullQuery,
  useGetUsersStatsFullQuery,
  useGetGeoBimDownloadsFullQuery,
  useGetWordExportsFullQuery,
} from "../../services/API/statisticsAPI";
import { toast } from "react-toastify";
import exportAllExports from "./Export/exportAllExports";

const buildSection = (title, headers, rows) => {
  if (!rows || rows.length === 0) {
    return [];
  }
  return [
    [title],
    headers.map((header) => header.label),
    ...rows.map((row) => headers.map((header) => row[header.key])),
  ];
};

function DownloadAll() {
  const { t } = useTranslation(["translation", "statistics"]);

  const userRegistrations = useGetUserRegistrationsFullQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const pdfExports = useGetPdfExportsFullQuery(undefined, { refetchOnMountOrArgChange: true });
  const userStats = useGetUsersStatsFullQuery(undefined, { refetchOnMountOrArgChange: true });
  const geobimDownloads = useGetGeoBimDownloadsFullQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const wordExports = useGetWordExportsFullQuery(undefined, { refetchOnMountOrArgChange: true });

  const queries = [userRegistrations, pdfExports, userStats, geobimDownloads, wordExports];
  const isLoading = queries.some((query) => query.isLoading);
  const hasError = queries.some((query) => query.error);

  if (isLoading || hasError) {
    return (
      <button className="btn btn-success" disabled>
        {hasError
          ? t("general.error_loading_data", { ns: "statistics" })
          : t("general.loading", { ns: "statistics" })}
      </button>
    );
  }

  const allData = [
    ...buildSection(
      "User Registrations",
      exportAllExports.headersRegistrationsFull(),
      exportAllExports.exportRegistrationsFull(userRegistrations.data)
    ),
    ...buildSection(
      "Pdf Exports",
      exportAllExports.pdfExportHeadersFull(),
      exportAllExports.pdfExportFull(pdfExports.data)
    ),
    ...buildSection(
      "User login statistics",
      exportAllExports.headersUserIteractionsFull(),
      exportAllExports.exportUserIteractionsFull(userStats.data)
    ),
    ...buildSection(
      "GeoBIM Tool Downloads",
      exportAllExports.geobimDownloadsHeadersFull(),
      exportAllExports.geobimDownloadsFull(geobimDownloads.data)
    ),
    ...buildSection(
      "Word Exports",
      exportAllExports.wordExportHeadersFull(),
      exportAllExports.wordExportFull(wordExports.data)
    ),
  ];

  return (
    <CSVLink
      className="btn btn-success"
      data={allData}
      filename={"stats_exports_all.csv"}
      onClick={() => {
        toast.success(t("exports.Downloaded", { ns: "statistics" }));
      }}
    >
      <Download size={16} className="me-2" />
      {t("exports.DownloadAll", { ns: "statistics" })}
    </CSVLink>
  );
}
export default DownloadAll;
